/* eslint-disable */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import NotificationBtn from './NotificationBtn'
import styled from '@emotion/styled'
import { css } from '@emotion/core'


const StyledDiv = styled('div')`
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.3);
  color: #fff;
  font-size: 12px;
  padding: 16px 24px 16px 16px;
  pointer-events: initial;
  &:not(:first-child) {
    margin-top: 10px;
  }
  max-width: ${({ type }) => ('fixed' === type ? '648px' : '304px')};
  display: ${({ type }) => ('fixed' === type ? 'flex' : 'block')};
  background-color: ${({ theme, color }) =>
    'red' === color
      ? theme.primary.base
      : 'blue' === color
      ? theme.secondary.dark
      : 'transparent'};
`

const footerStyles = {
  fixed: css`
    flex: 0 0 auto;
    padding-left: 24px;
    position: relative;
    display: flex;

    @media (max-width: 600px) {
      align-items: flex-start;
      justify-content: space-around;
    }

    @media (max-width: 500px) {
      display: block;
    }
  `,
  floating: css`
    margin-top: 24px;
  `,
}

const StyledFooter = styled('footer')`
  border-left: ${props =>
    props.type === 'fixed'
      ? `solid ${props.theme.tertiary.medium} 1px`
      : 'none'};
  ${props => props.type && footerStyles[props.type]}
`

const messageStyles = {
  fixed: css`
    margin: 0;
    flex: 1 1 auto;
    padding-right: 32px;
    @media (max-width: 600px) {
      display: table-cell;
      vertical-align: middle;
    }
  `,
  floating: css`
    margin: 0;
  `,
}

export default class Notification extends Component {
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    confirmBtnText: PropTypes.string,
    id: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    type: PropTypes.string,
  }

  static defaultProps = {
    className: '',
    confirmBtnText: 'Confirm',
    color: 'blue',
    type: 'floating',
  }

  handleCancel = () => this.props.onCancel(this.props)

  handleConfirm = () => this.props.onConfirm(this.props)

  render() {
    const { className, text, color, type, confirmBtnText } = this.props
    return (
      <StyledDiv color={color} type={type} className={className}>
        <p css={messageStyles[type]}>{text}</p>
        <StyledFooter type={type}>
          <NotificationBtn
            action={this.handleConfirm}
            color={color}
            type={type}
          >
            {confirmBtnText}
          </NotificationBtn>
          <NotificationBtn action={this.handleCancel} type={type} color={color}>
            Cancel
          </NotificationBtn>
        </StyledFooter>
      </StyledDiv>
    )
  }
}
